export default "__VITE_ASSET__53e38748__"